module.exports = __webpack_public_path__ + "img/2.36aaf0f0.jpg";